export default __webpack_public_path__ + "static/media/Roboto-Medium.b8c70ce5.woff";